import * as i18nStore from './i18n'
import { useStore } from 'effector-react'

export default () => useStore(i18nStore.store)
